import AxiosService from '../AxiosService';

export interface CommunicationModalRoute {
  type: 'internal' | 'external';
  url: string;
  params?: Record<string, any> | null;
}

export interface CommunicationModal {
  id: number;
  title: string;
  body: string;
  starts_at: string;
  ends_at: string;
  repeats: boolean;
  /** Rótulo do botão de ação. Vem nulo em modal apenas informativa. */
  cta_label?: string | null;
  /** Rótulo do botão que fecha sem agir. Nulo = texto padrão do app. */
  dismiss_label?: string | null;
  /** Destino do botão de ação. Nulo = modal sem navegação. */
  route?: CommunicationModalRoute | null;
}

const GetActiveCommunicationModals = async (): Promise<CommunicationModal[]> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('v1/client/communication-modals/active');
  return response.data?.data ?? [];
};

const MarkCommunicationModalViewed = async (modalId: number): Promise<void> => {
  const instance = AxiosService.createAuthAxiosInstance();
  await instance.post(`v1/client/communication-modals/${modalId}/viewed`);
};

export default {
  GetActiveCommunicationModals,
  MarkCommunicationModalViewed,
};
